import { Chip, SxProps } from "@outschool/backpack";
import { useTranslation } from "@outschool/localization";
import { useSession } from "@outschool/ui-auth";
import React from "react";

import { useEsaUserWithoutPaidMembership } from "../../hooks/useEsaUserWithoutPaidMembership";

export function FreeForMembersChip({ sx }: { sx?: SxProps }) {
  const { t } = useTranslation("client\\components\\Chips\\FreeForMembersChip");
  const { isEsaSession } = useSession();
  const { isEsaUserWithoutPaidMembership } = useEsaUserWithoutPaidMembership();

  if (isEsaSession || isEsaUserWithoutPaidMembership) {
    return null;
  }

  return (
    <Chip
      label={t`Free for members`}
      size="small"
      sx={[
        theme => ({
          color: theme.palette.primary.dark,
          backgroundColor: theme.palette.warning.main,
        }),
        ...(Array.isArray(sx) ? sx : [sx]),
      ]}
    />
  );
}
